export default "__VITE_ASSET__DyLAH0We__"